export default {
    name: "merchant",
    mounted(){
        this.$track("浏览商家入驻页面",this.$route.fullPath);
    }
}